(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ke-best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ke-best-sellers')) {
    customElements.define('ke-best-sellers', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.tabs = Array.from(this.querySelectorAll('[data-bs-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-bs-panel]'));
        if (!this.tabs.length || !this.panels.length) return;
        this.catalog = this.dataset.mode === 'catalog';
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.offsets = { clothing: 0, sneakers: 0 };
        this.active = this.catalog && new URLSearchParams(window.location.search).get('department') === 'sneakers' ? 'sneakers' : 'clothing';
        this.status = this.querySelector('[data-bs-status]');
        this.querySelector('[data-bs-tabs]').setAttribute('role', 'tablist');
        this.querySelector('[data-bs-tabs]').hidden = false;
        this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.bsTab === panel.dataset.bsPanel).id);
        });
        this.dataset.enhanced = '';
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-bs-tab]');
          if (tab && this.contains(tab)) this.select(tab.dataset.bsTab);
          const step = event.target.closest('[data-bs-step]');
          if (!step || !this.contains(step) || step.disabled) return;
          this.offsets[this.active] += Number(step.dataset.bsStep) * this.pageSize();
          this.render(true);
          this.currentPanel().querySelector('[data-bs-grid]')?.focus({ preventScroll: true });
        }, { signal });
        this.addEventListener('keydown', event => {
          const current = event.target.closest('[data-bs-tab]');
          if (!current || !this.contains(current)) return;
          let index = this.tabs.indexOf(current);
          if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') index = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(this.tabs[index].dataset.bsTab);
          this.tabs[index].focus();
        }, { signal });
        this.mobile.addEventListener('change', () => {
          const focused = this.querySelector(':focus');
          this.render(false);
          if (focused?.closest('[data-bs-card]')?.hidden) this.currentPanel().querySelector('[data-bs-grid]')?.focus({ preventScroll: true });
        }, { signal });
        this.render(false);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      pageSize() { return this.mobile.matches ? 2 : 4; }
      currentPanel() { return this.panels.find(panel => panel.dataset.bsPanel === this.active); }
      select(department) {
        this.active = department;
        this.render(true);
        if (this.catalog) {
          const url = new URL(window.location.href);
          url.searchParams.set('department', department);
          window.history.replaceState(window.history.state, '', url);
        }
      }
      render(announce) {
        this.tabs.forEach(tab => {
          const selected = tab.dataset.bsTab === this.active;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => {
          const department = panel.dataset.bsPanel;
          panel.hidden = department !== this.active;
          const cards = Array.from(panel.querySelectorAll('[data-bs-card]'));
          const count = cards.length;
          const size = this.pageSize();
          const lastStart = Math.max(0, Math.floor((count - 1) / size) * size);
          const first = this.catalog ? 0 : Math.max(0, Math.min(Math.floor(this.offsets[department] / size) * size, lastStart));
          this.offsets[department] = first;
          const last = this.catalog ? count : Math.min(first + size, count);
          cards.forEach((card, index) => { card.hidden = !this.catalog && (index < first || index >= last); });
          const pager = panel.querySelector('[data-bs-pager]');
          pager.hidden = this.catalog || count === 0;
          panel.querySelector('[data-bs-range]').textContent = count ? `${first + 1}–${last} / ${count}` : '';
          panel.querySelector('[data-bs-step="-1"]').disabled = first === 0;
          panel.querySelector('[data-bs-step="1"]').disabled = last >= count;
          if (announce && department === this.active) {
            const text = count ? this.dataset.announcement : this.dataset.emptyAnnouncement;
            const values = { department: panel.dataset.label, first: first + 1, last, count };
            this.status.textContent = text.replace(/\[(department|first|last|count)\]/g, (_, key) => values[key]);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
